import React from 'react'
import PropTypes from 'prop-types'

const DefaultFeatureFilter = props => (
  <select
    className="filter-header text-uppercase"
    onChange={props.setFilterValue(
      'defaultFeature',
      props.profile.filter,
      props.profile.sort
    )}
  >
    <option className="text-uppercase" value="">
      CREATOR / CLIENT
    </option>
    <option className="text-uppercase" value="product">
      Creator
    </option>
    <option className="text-uppercase" value="project">
      Client
    </option>
  </select>
)

DefaultFeatureFilter.propTypes = {
  profile: PropTypes.shape({
    filter: PropTypes.string.isRequired,
    sort: PropTypes.string.isRequired,
  }).isRequired,
  setFilterValue: PropTypes.func.isRequired,
}

export default DefaultFeatureFilter
